import { Show, JSX } from 'solid-js'

interface FormModalProps {
  title: string
  isOpen: boolean
  onClose: () => void
  onSubmit?: (e: Event) => void
  children: JSX.Element
}

const FormModal = (props: FormModalProps) => {
  return (
    <Show when={props.isOpen}>
      <div
        class="fixed bottom-0 left-0 right-0 top-0 z-[200] flex h-screen items-center justify-center overflow-y-auto overflow-x-hidden bg-black/80 backdrop-blur"
        onClick={props.onClose}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          class="background m-5 w-full rounded-[22px] border-[1px] border-white p-[18px] backdrop-blur md:w-3/4 md:p-8 lg:w-1/3"
        >
          <div class="font-clash">
            <h3 class="mb-3 mt-1 font-clash text-[32px] font-bold leading-normal text-white">
              {props.title}
            </h3>
            <form onSubmit={props.onSubmit}>{props.children}</form>
          </div>
        </div>
      </div>
    </Show>
  )
}

export default FormModal
